<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit" showExport @handleExport="handleExport"></filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize=15 :dataSource="datas" :pagination="pagination" :loading="loading" :scroll="scroll" @tableChange="tableChange">
    </standard-table>

  </div>
</template>

<script>
import { api } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {},
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "orderNo",
          name: "订单号"
        },
        {
          type: "select",
          key: "organizationId",
          name: "销售组织",
          options: []
        },
        {
          type: "input",
          key: "dealerName",
          name: "经销商"
        },
        {
          type: "select",
          key: "orderType",
          name: "订单类型",
          options: [
            { name: "标准订单", val: 0 },
            { name: "定制订单", val: 1 },
            { name: "促销订单", val: 2 }
          ]
        },
        {
          type: "dateFilter",
          key: "effective",
          name: "下单时间"
        },
        {
          type: "select",
          key: "status",
          name: "状态",
          options: [
            { name: "取消", val: -1 },
            { name: "初始", val: 0 },
            { name: "待分公司审核", val: 1 },
            { name: "分公司审核通过", val: 2 },
            { name: "分公司审核不通过", val: 3 },
            { name: "待总部审核", val: 4 },
            { name: "总部审核通过", val: 5 },
            { name: "总部审核不通过", val: 6 },
            { name: "待出库", val: 7 },
            { name: "部分出库", val: 8 },
            { name: "完成", val: 9 }
          ]
        },
        {
          type: "cascader",
          key: "groupId",
          name: "客户分组",
          options: []
        },
        {
          type: "cascader",
          key: "departmentId",
          name: "部门",
          options: []
        },
        {
          type: "input",
          key: "departmentName",
          name: "部门名"
        },
      ],
      scroll: { x: 1540 },
      columns: [
        {
          title: "订单类型",
          width: 110,
          dataIndex: "orderType",
          sorter: true,
          customRender: (text, row, index) => {
            return row.orderTypeStr;
          }
        },
        {
          title: "订单号",
          width: 120,
          dataIndex: "orderNo",
          sorter: true
        },
        // {
        //   title: "金蝶单号",
        //   width: 120,
        //   dataIndex: "erpOrderNo",
        //   sorter: true
        // },
        {
          title: "销售组织",
          width: 180,
          dataIndex: "organizationName"
        },
        {
          title: "部门",
          width: 120,
          dataIndex: "departmentName"
        },
        {
          title: "经销商",
          width: 200,
          dataIndex: "dealerName"
        },
        {
          title: "发货方式",
          width: 120,
          dataIndex: "deliveryMethod",
          customRender: (text, row, index) => {
            return row.deliveryMethodStr;
          }
        },
        {
          title: "订单来源",
          width: 120,
          dataIndex: "orderSource",
          customRender: (text, row, index) => {
            return row.orderSourceStr;
          }
        },
        {
          title: "下单时间",
          width: 180,
          dataIndex: "creationTime",
          customRender: (text, row, index) => {
            return this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        },
        {
          title: "产品编码",
          width: 200,
          dataIndex: "productCode"
        },
        {
          title: "产品名称",
          width: 200,
          dataIndex: "productName"
        },
        {
          title: "规格",
          width: 200,
          dataIndex: "specDes"
        },
        {
          title: "数量",
          width: 70,
          dataIndex: "quantity"
        },
        ,
        {
          title: "价格",
          width: 100,
          dataIndex: "price"
        },
        {
          title: "是否定制",
          width: 100,
          dataIndex: "isCustom",
          customRender: (text, row, index) => {
            return row.isCustom ? "是" : "否";
          }
        },
        {
          title: "是否套件",
          width: 100,
          dataIndex: "isVirtual",
          customRender: (text, row, index) => {
            return row.isVirtual ? "是" : "否";
          }
        },
        {
          title: "父产品",
          width: 200,
          dataIndex: "parentProductName"
        },
        {
          title: "备注",
          width: 200,
          dataIndex: "notes"
        },
        {
          title: "活动",
          width: 200,
          dataIndex: "activityName"
        },
        {
          title: "预计交期",
          width: 100,
          dataIndex: "expectedDeliveryDate",
          customRender: (text, row, index) => {
            return this.formatDate(row.expectedDeliveryDate, "YYYY-MM-DD");
          }
        },
        {
          title: "要货日期",
          width: 100,
          dataIndex: "dealerExpectedDeliveryDate",
          customRender: (text, row, index) => {
            return this.formatDate(
              row.dealerExpectedDeliveryDate,
              "YYYY-MM-DD"
            );
          }
        },
        {
          title: "货运部",
          width: 150,
          dataIndex: "status",
          customRender: (text, row, index) => {
            return row.freightName;
          }
        },
        {
          title: "货运部电话",
          width: 150,
          dataIndex: "status",
          customRender: (text, row, index) => {
            return row.freightTelephone;
          }
        },
        {
          title: "状态",
          width: 150,
          dataIndex: "status",
          customRender: (text, row, index) => {
            return row.statusStr;
          }
        }
      ],
      datas: [],
      filterdata: JSON.parse(JSON.stringify(config.pageFilter)),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      qxParams: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "1300px",
      childWidth: "0px",
      childHeight: "0px",
      explain: "",
      visible: false,
      permission: [],
      title: "",
      allGroups:[],
      allDepartments:[]
    };
  },
  async mounted() {
    this.GetOrganizationOptions();
    this.getAllGroups();
    this.getAllDepartment();
    this.permission = this.getPermission("Order");
    this.getDatas(this.filterdata);
    this.scroll.x = 0;
    this.columns.forEach(a => {
      this.scroll.x = a.width + this.scroll.x;
    });
  },
  methods: {
    handleExport(p) {
      this.getFilterdata(p);
      this.doExport(this.storeFilterdata);
    },
    async doExport(options) {
      options = Object.assign({ rankType: 3 }, options);
      let r = await api.CreateExportTask({
        taskType: 1,
        exportType: 2,
        fileName: "订单报表",
        queryParameter: JSON.stringify(options)
      });
      if (r) {
        this.$message.success(
          "创建导出任务成功，请稍等几分钟后到报表导出任务中下载导出结果！"
        );
      }
    },
    async GetOrganizationOptions() {
      let org = await api.GetOrganizationSelect();
      if (org) {
        let organizationOptions = [];
        org.forEach(a => {
          organizationOptions.push({
            name: a.text,
            val: a.value
          });
        });
        this.filter.filter(
          a => a.key == "organizationId"
        )[0].options = organizationOptions;
      }
    },
    async getAllGroups() {
      let groupList = await api.GetAllDealerGroups();
      if (groupList) {
        this.allGroups = groupList;
      }
      this.filter.filter(
        a => a.key == "groupId"
      )[0].options = groupList;
    },
    async getAllDepartment() {
      let departmentList = await api.GetAllDepartmentData();
      if (departmentList) {
        this.allDepartments = departmentList;
      }
      this.filter.filter(
        a => a.key == "departmentId"
      )[0].options = departmentList;
    },
    getFilterdata(p) {
      this.filterdata.orderNo = p.values.orderNo;
      this.filterdata.organizationId = p.values.organizationId;
      this.filterdata.orderType = p.values.orderType;
      this.filterdata.status = p.values.status;
      this.filterdata.departmentName=p.values.departmentName;
      //this.filterdata.dealerGroup=p.values.dealerGroup;
      console.log(p.values.groupId);
      this.filterdata.departmentId=p.values.departmentId!=null&&p.values.departmentId.length>1?p.values.departmentId[1]!=null?p.values.departmentId[1]:null:null;
      if(p.values.groupId!=null&&p.values.groupId.length>=1){
        if(p.values.groupId[2]!=null){
          this.filterdata.groupId=p.values.groupId[2];
        }
        else if(p.values.groupId[1]!=null){
          this.filterdata.groupId=p.values.groupId[1];
        }
        else {
          this.filterdata.groupId=p.values.groupId[0]!=null?p.values.groupId[0]:null;
        }        
      }
      else {this.filterdata.groupId=null}
      this.filterdata.startTime =
        p.values.effective[0] != null ? p.values.effective[0].valueOf() : null;
      this.filterdata.endTime =
        p.values.effective[1] != null ? p.values.effective[1].valueOf() : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
    },
    handleSubmit(p) {
      this.pagination.current = 0;
      this.getFilterdata(p);
      this.getDatas(this.filterdata);
    },

    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.filters.code && table.filters.code.length > 0) {
        console.log(table.filters);
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetOrderMasterExportList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Reports/OrderExport/List.vue